import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {HomeMenuPresenter} from "./homeMenuPresenter";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class HomeMenuView extends ViewBase implements IView {

    public _presenter: HomeMenuPresenter;
    
    constructor(viewName:string, router:Router, dependencyContainer: ParcelDependencyContainer) {
        super(viewName, router, dependencyContainer);
    }


    public set displayName(displayName){
        this.setTextById('display-name', displayName);
    }
    
    public set handle(handle){
        this.setTextById('handle-name', handle);
    }
    
    public setUpcomingDate(date){
        this.setTextById('upcoming-date', date);
    }


    public setUpcomingTime(time){
        this.setTextById('upcoming-time', time);
    }

    public setPresenter(presenter: HomeMenuPresenter) {
        this._presenter = presenter;
    }
    
    public showUpcomingDate(show){
        this.setElementVisibility('.upcoming-date-card', show);
    }
    
    public showLoadingUpcomingDate(show){
        this.setElementVisibility('#loading-upcoming-date-card', show);
    }

    public render(): void {
    }
    
    public showLoggedIn(value: boolean) {
        this.setElementVisibility('#not-logged-in', !value);
        this.setElementVisibility('#logged-in', value);
    }

    public showScheduleEstimate(show: boolean) {
        this.setElementVisibility('#schedule-time', show);
    }
    
}